import { Flex, rem, Stack, Text, Textarea } from "@mantine/core";
import { IconFileText } from "@tabler/icons-react";
import type { ReactNode } from "react";
import { useFormInputStyles } from "@/design-system/components/form/hooks/useFormInputStyles";
import { TabSectionHeader } from "../TabSectionHeader";
import classes from "./AgentForm.module.css";

export const INSTRUCTIONS_DESCRIPTION =
  "O papel do agente, o tom e o que ele pode ou não fazer na conversa.";

const PROMPT_MAX_LENGTH = 50000 as const;

interface AgentFormProps {
  prompt: string;
  onPromptChange: (value: string) => void;
  /** Botão de salvar desta aba (nome + prompt), montado pela página. */
  headerAction?: ReactNode;
}

// O nome do agente saiu daqui: com a página em abas (SA-1351) ele é editado no
// próprio título. O salvar é da aba (`headerAction`), não da página.
export const AgentForm = ({
  prompt,
  onPromptChange,
  headerAction,
}: AgentFormProps) => {
  const { resolvedStyles } = useFormInputStyles({});

  return (
    <Flex
      direction="column"
      gap="lg"
      w="100%"
      flex={1}
      className={classes.root}>
      <Stack
        gap={rem(8)}
        className={classes.field}>
        {/* Mesmo cabeçalho das outras abas (ícone, título, selo do que a IA faz). */}
        <TabSectionHeader
          icon={
            <IconFileText
              size={20}
              color="var(--mantine-color-R500-0)"
            />
          }
          title="Instruções do agente"
          badge="A IA SEGUE"
          description={INSTRUCTIONS_DESCRIPTION}
          action={headerAction}
        />

        {/* Ocupa toda a altura que sobra na página: prompt é texto longo e a
            rolagem acontece dentro do campo, não na página. */}
        <Textarea
          aria-label="Instruções do agente"
          value={prompt}
          onChange={(event) => {
            const value = event.currentTarget.value;
            onPromptChange(
              value.length > PROMPT_MAX_LENGTH
                ? value.slice(0, PROMPT_MAX_LENGTH)
                : value
            );
          }}
          size="md"
          styles={resolvedStyles}
          classNames={{
            root: classes.textareaRoot,
            wrapper: classes.textareaWrapper,
            input: classes.textareaInput,
          }}
        />
        <Text
          fz="xs"
          c="dimmed"
          ta="right">
          {prompt.length.toLocaleString("pt-BR")}/
          {PROMPT_MAX_LENGTH.toLocaleString("pt-BR")} caracteres
        </Text>
      </Stack>
    </Flex>
  );
};

export default AgentForm;
